import React, { useContext, useState, useEffect, useCallback } from "react";
import { Spinner, Table } from "react-bootstrap";
import "./hostlisting.css";
import DemoContext from "context/DemoContext";
import moment from "moment";
import { Trash3 } from "react-bootstrap-icons";
import AuthContext from "context/AuthContext";
import ProfileContext from "context/ProfileContext";
import CustomModal from "components/Modal/CustomModal";
import { BlankImg } from "assets/images";
import ImgComponent from "components/imgComponent";
import InfiniteScroll from 'react-infinite-scroll-component';
import useCan from "hooks/useCan";
import { CAPABILITIES } from "utils/capabilities";

const FallbackHostList = () => {
  const {
    listFallbackHosts,
    fallbackHostNext,
    setFallbackHost,
    deleteFallbackHost,
    getAllFallbackHost,
    allhosts
  } = useContext(DemoContext);
  let { userProfile } = useContext(AuthContext);
  const { can } = useCan();
  const canManageHosts = can(CAPABILITIES.HOSTS_MANAGE);
  let { updatedHostsOnce } = useContext(ProfileContext);
  const [loadingPros, setLoadingPros] = useState(false);
  const [showAddFallback, setShowAddFallback] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showDeleteSucess, setShowDeleteSucess] = useState(false);
  const [selectedHostId, setSelectedHostId] = useState("");
  const [hasMore, setHasMore] = useState(true);

  const handleClose = () => {
    setShowAddFallback(false);
  };
  const handleCloseError = () => {
    setShowError(false);
  };
  const handleCloseDeleteSucess = () => {
    setShowDeleteSucess(false);
  };

  // Fetch more data for infinite scroll (scoped to this tab container)
  const fetchMoreData = useCallback(() => {
    if (!hasMore || loadingPros || !fallbackHostNext) return;
    setLoadingPros(true);
    let res = getAllFallbackHost(new URL(fallbackHostNext).search, true);
    res.then(() => {
      setLoadingPros(false);
      // If no next step after loading, set hasMore to false
      if (!fallbackHostNext) {
        setHasMore(false);
      }
    }).catch(() => {
      setLoadingPros(false);
    });
  }, [hasMore, loadingPros, fallbackHostNext, getAllFallbackHost]);

  const addNewFallbackHost = async (host_id) => {
    setLoadingPros(true);
    let store_identifier = userProfile?.store?.store_id;
    let payload = {
      store_identifier: store_identifier,
      host: host_id,
    };
    try {
      let res = await setFallbackHost(payload);
      if (res.status === 201) {
        getAllFallbackHost(`?order=true`);
        setShowAddFallback(false);
        setLoadingPros(false);
        setHasMore(true); // Reset for fresh data
      } else {
        setShowAddFallback(false);
        setLoadingPros(false);
        setShowError(true);
      }
    } catch (err) {
      setLoadingPros(false);
      setShowAddFallback(false);
      setShowError(true);
    }
  };

  const fallbackHostDelete = async (id) => {
    setLoadingPros(true);
    try {
      let res = await deleteFallbackHost(id);
      if (res.status === 204) {
        getAllFallbackHost(`?order=true`);
        setLoadingPros(false);
        setShowDeleteSucess(true);
        setHasMore(true); // Reset for fresh data
      }
    } catch (err) {
      console.log(err);
      setLoadingPros(false);
    }
  };

  const getFallbackHosts = () => {
    if (listFallbackHosts) {
      if (listFallbackHosts?.length < 1 && !loadingPros) {
        return (
          <tr>
            <td colSpan="4">There aren't any fallback hosts yet!</td>
          </tr>
        );
      } else {
        const hostRows = listFallbackHosts?.map((listFallbackHost, index) => {
          return (
            <tr key={`${listFallbackHost.id || index}`}>
              <td className="image-title-wrapper">
                <ImgComponent
                  className="host-pp-small"
                  src={
                    listFallbackHost?.host?.profile_picture?.file !== null
                      ? listFallbackHost?.host?.profile_picture?.file
                      : BlankImg
                  }
                  alt="user"
                />
                {listFallbackHost?.host?.first_name}{" "}
                {listFallbackHost?.host?.last_name}
              </td>
              <td>
                {moment(listFallbackHost?.created_at).format("YYYY-MM-DD")}
              </td>
              <td>{listFallbackHost?.host?.email}</td>
              <td>
                {canManageHosts && (
                  <button
                    className="btn"
                    style={{ background: "transparent" }}
                    onClick={() => {
                      fallbackHostDelete(listFallbackHost?.id);
                    }}
                  >
                    <Trash3 style={{ fontSize: "20px", color: "red" }} />
                  </button>
                )}
              </td>
            </tr>
          );
        });

        // Add loading spinner at the end when loading more
        if (loadingPros && listFallbackHosts && listFallbackHosts.length > 0) {
          hostRows.push(
            <tr key="loading">
              <td colSpan="4">
                <div className="d-flex justify-content-center py-3">
                  <Spinner animation="grow" />
                  <Spinner animation="grow" />
                  <Spinner animation="grow" />
                </div>
              </td>
            </tr>
          );
        }

        return hostRows;
      }
    } else {
      return (
        <tr>
          <td colSpan="4">There aren't any fallback hosts yet!</td>
        </tr>
      );
    }
  };

  return (
    <div>
      <div className="info-fallbackHost">
        <div className="text-end">
          <div
            className=" btn btn-primary bg-secondary m-3 "
            onClick={() => {
              setShowAddFallback(true);
            }}
            hidden={!canManageHosts}
          >
            + Add Fallback Real Customer
          </div>
        </div>
      </div>
      <CustomModal
        showStatus={showAddFallback}
        clickStatus={handleClose}
        buttonMessage="Close"
        closeStatus={handleClose}
        title="Add Fallback Real Customer"
        message={
          <HostLists
            updatedHostsOnce={allhosts}
            selectedHostId={selectedHostId}
            setSelectedHostId={setSelectedHostId}
            addNewFallbackHost={addNewFallbackHost}
          />
        }
        secondButton={false}
        secondMessage="none"
      />
      <CustomModal
        showStatus={showError}
        clickStatus={handleCloseError}
        buttonMessage="Close"
        closeStatus={handleCloseError}
        title="User Already Exist"
        message={"This User Already exist in fallback host list."}
        secondButton={false}
        secondMessage="none"
      />
      <CustomModal
        showStatus={showDeleteSucess}
        clickStatus={handleCloseDeleteSucess}
        buttonMessage="Close"
        closeStatus={handleCloseDeleteSucess}
        title="Deleted Sucessfully"
        message={"User deletion successful."}
        secondButton={false}
        secondMessage="none"
      />
      <div id="fallbackScrollableDiv" style={{ height: '600px', overflow: 'auto' }}>
        <InfiniteScroll
          dataLength={listFallbackHosts?.length || 0}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={
            loadingPros && listFallbackHosts?.length > 0 && (
              <div className="d-flex justify-content-center py-3">
                <Spinner animation="grow" />
                <Spinner animation="grow" />
                <Spinner animation="grow" />
              </div>
            )
          }
          scrollableTarget="fallbackScrollableDiv"
          endMessage={
            <div className="text-center py-3 text-muted">
              {!hasMore && listFallbackHosts?.length > 0 && "You have seen all fallback hosts!"}
            </div>
          }
        >
        <Table className="table-store" responsive>
          <thead>
            <tr>
              <th scope="col">
                <div className="arrows">Real Customer</div>
              </th>
              <th scope="col">
                <div className="arrows">Created At </div>
              </th>
              <th scope="col">
                <div className="arrows">Email</div>
              </th>
              <th scope="col">
                <div className="arrows">Action</div>
              </th>
            </tr>
          </thead>
          <tbody>{getFallbackHosts()}</tbody>
        </Table>
        </InfiniteScroll>
      </div>
      
      {/* Show loading spinner for initial load */}
      {loadingPros && (!listFallbackHosts || listFallbackHosts.length === 0) && (
        <div className="d-flex justify-content-center py-4">
          <Spinner animation="grow" />
          <Spinner animation="grow" />
          <Spinner animation="grow" />
        </div>
      )}
    </div>
  );
};

export default FallbackHostList;

export const HostLists = ({
  updatedHostsOnce,
  selectedHostId,
  setSelectedHostId,
  addNewFallbackHost,
}) => {
  return (
    <div>
      <h5>Choose Your Fallback Real Customer</h5>
      <select
        className="form-select-lg"
        name="selectHost"
        defaultValue=""
        style={{ width: "100%" }}
        onChange={(e) => setSelectedHostId(e.target.value)}
      >
        <option value="" disabled>
          Select Real Customer
        </option>
        {updatedHostsOnce.map((res) => {
          return (
            <option value={res?.user?.id} key={res?.user?.id}>
              {res?.user?.first_name} {res?.user?.last_name}
            </option>
          );
        })}
      </select>
      <div className="text-end">
        <button
          className="btn btn-primary p-2 m-1"
          onClick={() => {
            addNewFallbackHost(selectedHostId);
          }}
          disabled={!selectedHostId}
        >
          Add
        </button>
      </div>
    </div>
  );
};